import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    /* Registro de usuarios */
    usuarios: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    nombre: '',
    incluirInactivos: false,

    list: [],
    selectList: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.usuarios = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.nombre = '';
        state.incluirInactivos = false;
    },

    'INICIALIZAR'(state) {
        state.usuarios = [];
    },
    'SET_USUARIOS'(state, usuarios) {
        state.usuarios = usuarios;
    },
    'PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_LIST'(state) {
        state.list = [];
        state.selectList = [];
    },
    'SET_LIST'(state, list) {
        state.list = list;
        state.selectList = list.map(usuario => usuario.nombreCompleto.trim());
    },
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getUsuarios: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR');

            var queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;
            
            if (state.nombre != '') {
                queryString += '&nombre=' + state.nombre;
            }
            if (state.incluirInactivos) {
                if (state.incluirInactivos == true || state.incluirInactivos == 'true') {
                    queryString += '&incluirInactivos= true';
                }
            }

            apiAxios.get('usuarios' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('PAGINATION', params);
                    }
                    commit('SET_USUARIOS', res.data);
                    resolve();
                })
                .catch(error =>  reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getList: ({commit}, params) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST');

            let queryString = '';
            
            if (params) {
                if (params.incluirInactivos) {
                    queryString += (queryString == ''? '?' : '&') + 'incluirInactivos= true';
                }
            }

            apiAxios.get('usuarios/list' + queryString)
                .then(res => {
                    let list = res.data.map(usuario => ({
                        ...usuario,
                        nombre: usuario.nombreCompleto.trim()
                    }))
                    commit('SET_LIST', list);
                    resolve();
                })
                .catch(error =>  reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getUsuariosAsignar: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST');

            apiAxios.get('usuarios/asign')
                .then(res => {
                    commit('SET_LIST', res.data);
                    resolve();
                })
                .catch(error =>  reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getUsuariosAsignarBrief: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST');

            apiAxios.get('usuarios/asignar-brief')
                .then(res => {
                    commit('SET_LIST', res.data);
                    resolve();
                })
                .catch(error =>  reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getUsuariosCoordinadores: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST');

            apiAxios.get('usuarios/coordinadores')
                .then(res => {
                    commit('SET_LIST', res.data);
                    resolve();
                })
                .catch(error =>  reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getUsuariosAbrirCaja: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST');

            apiAxios.get('usuarios/abrircaja')
                .then(res => {
                    commit('SET_LIST', res.data);
                    resolve();
                })
                .catch(error =>  reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

const getters = {
    getField,

    list(state) {
        return state.list;
    },
    selectList(state) {
        return state.selectList;
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}